import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    n: "01",
    title: "Compra e Venda",
    text: "Curadoria completa de imóveis urbanos e rurais, com negociação transparente do primeiro contato à escritura.",
  },
  {
    n: "02",
    title: "Avaliação de Imóveis",
    text: "Laudo de valor justo baseado em dados de mercado, para você vender ou comprar com total segurança.",
  },
  {
    n: "03",
    title: "Consultoria Imobiliária",
    text: "Orientação personalizada para investidores e famílias: financiamento, documentação e planejamento.",
  },
  {
    n: "04",
    title: "Imóveis Rurais",
    text: "Fazendas, chácaras e sítios com análise de solo, acesso e potencial produtivo — do lazer ao agronegócio.",
  },
];

export const Services = () => (
  <section id="servicos" className="py-24 md:py-36" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-14 max-w-2xl"
      >
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-seed-salad">Serviços</p>
        <h2 className="font-heading text-4xl font-black tracking-tighter text-seed-deep sm:text-5xl" data-testid="services-title">
          Do primeiro olhar à chave na mão.
        </h2>
      </motion.div>

      <div>
        {services.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group grid cursor-default grid-cols-[auto_1fr_auto] items-center gap-6 border-b border-seed-deep/15 py-8 transition-colors duration-500 hover:bg-white md:gap-12 md:px-6"
            data-testid={`service-item-${s.n}`}
          >
            <span className="font-heading text-2xl font-light text-seed-salad/70 md:text-3xl">{s.n}</span>
            <div>
              <h3 className="font-heading text-xl font-bold tracking-tight text-seed-deep transition-colors duration-300 group-hover:text-seed-salad md:text-2xl">
                {s.title}
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-seed-deep/60 md:text-base">{s.text}</p>
            </div>
            <ArrowUpRight
              size={26}
              className="text-seed-deep/30 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-seed-vivid"
            />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
